<h1 mat-dialog-title>Chỉnh sửa trường thông tin</h1>
<div mat-dialog-content>
    <div class="row">
        <div class="col-md-12">
            <mat-form-field appearance="outline">
                <input matInput placeholder="Tên trường" [(ngModel)]="data.label" />
             </mat-form-field>
        </div>
        <!-- <div class="col-md-6">
            <mat-form-field appearance="outline">
                <input matInput placeholder="Mô tả" [(ngModel)]="data.description" />
             </mat-form-field>
        </div> -->
    </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="save()">Xác nhận</button>
  <button mat-button mat-dialog-close color="warn">Hủy</button>
</div>
